import { PusatResolusiV2RepositoryInterface } from "@/data/persistences/repositories/contracts/PusatResolusiV2RepositoryInterface";
import ApiService from "../../services/ApiService";
import { PusatResolusiV2Mapper } from "@/data/persistences/mappers/PusatResolusiV2Mapper";
import { PusatResolusiV2Endpoint } from "../../endpoints/PusatResolusiV2Endpoint";
import {
  CheckTicketPusatResolusiRequest,
  FinishIssuePusatResolusiV2Request,
  GetConversationRequest,
  ListTicketPusatResolusiRequest,
  SubmitNotePusatResolusiRequest,
  SendChatPusatResolusiRequest,
  ListSTTPusatResolusi,
  TicketCounterPusatResolusiRequest,
  SubmitFeedbackApiRequest,
  FollowTicketApiRequest,
  AddTemplatePusatResolusiRequest,
  GetTicketActionRequest,
  DownloadLaporanRequest,
  CheckCategoryPusatResolusiRequest,
  ReopenPusatResolusiV2Request
} from "@/data/payload/api/PusatResolusiV2ApiRequest";
import {
  CategoryPusatResolusi,
  CheckIssuePusatResolusi,
  TicketListItem,
  TicketPusatResolusiDetail,
  TicketDetail,
  TicketAction,
  PusatResolusiSTTData,
  MentionsData,
  HistoryChatResponse,
  Conversation,
  TemplateChat,
  BulkDownload
} from "@/domain/entities/PusatResolusiV2";
import { ResponsePayload } from "@/domain/entities/ResponsePayload";
import {
  AddTemplatePusatResolusiRequestInterface,
  CreatePusatResolusiV2RequestInterface,
  SendChatPusatResolusiV2RequestInterface,
  DownloadLaporanPusatResolusiV2RequestInterface
} from "@/data/payload/contracts/PusatResolusiV2Request";
import { getHubData, getToken } from "../../misc/Cookies";
import { Endpoints } from "../../misc/Endpoints";
import { ApiRequestList } from "@/domain/entities/MainApp";

export class PusatResolusiV2ApiRepository
  implements PusatResolusiV2RepositoryInterface {
  private readonly service: ApiService;
  private readonly mapper: PusatResolusiV2Mapper;
  private readonly endpoints: PusatResolusiV2Endpoint;

  constructor(
    service: ApiService,
    mapper: PusatResolusiV2Mapper,
    endpoints: PusatResolusiV2Endpoint
  ) {
    this.service = service;
    this.mapper = mapper;
    this.endpoints = endpoints;
  }

  async submitFeedback(
    id: number,
    payload: SubmitFeedbackApiRequest
  ): Promise<boolean> {
    await this.service.invoke(
      "POST",
      this.endpoints.feedback(id),
      undefined,
      payload
    );

    return true;
  }
  async checkTicket(
    params: CheckTicketPusatResolusiRequest
  ): Promise<TicketPusatResolusiDetail> {
    const res = await this.service.invoke(
      "GET",
      this.endpoints.checkTicket(params)
    );

    return this.mapper.convertCheckTicketPusatResolusiFromApi(res);
  }

  async checkTicketV2(
    params: CheckTicketPusatResolusiRequest
  ): Promise<TicketPusatResolusiDetail[]> {
    const res = await this.service.invoke(
      "GET",
      this.endpoints.checkTicketV2(params)
    );

    return this.mapper.convertCheckTicketPusatResolusiV2FromApi(res);
  }
  
  async checkCategory(
    payload: CheckCategoryPusatResolusiRequest
  ): Promise<boolean> {
    await this.service.invoke(
      "POST",
      this.endpoints.checkCategory(),
      {},
      payload as CheckCategoryPusatResolusiRequest
    );
    return true;
  }

  async getListCategory(
    params: CheckTicketPusatResolusiRequest
  ): Promise<CategoryPusatResolusi[]> {
    const res = await this.service.invoke(
      "GET",
      this.endpoints.getListCategory(params)
    );

    return this.mapper.convertListCategoryPusatResolusiFromApi(res);
  }

  async getTicketCounter(
    params: TicketCounterPusatResolusiRequest
  ) {
    const res = await this.service.invoke(
      "GET",
      this.endpoints.getTicketCounter(params)
    );

    return this.mapper.convertNotificationTicketPusatResolusiFromApi(res);
  }

  async getListTicket(
    params: ListTicketPusatResolusiRequest
  ) {
    const response = await this.service.invoke(
      "GET",
      this.endpoints.getTicketList(params)
    );

    return this.mapper.convertListTicketPusatResolusiFromApi(response);
  }

  async getSTTList(params: ListSTTPusatResolusi) {
    const response = await this.service.invoke(
      "GET",
      this.endpoints.getSTTList(params)
    );

    return this.mapper.convertSTTListFromApi(response);
  }

  async checkIssue(
    params: CheckTicketPusatResolusiRequest
  ): Promise<CheckIssuePusatResolusi> {
    const res = await this.service.invoke(
      "GET",
      this.endpoints.checkIssue(params)
    );

    return this.mapper.convertCheckIssuePusatResolusiFromApi(res);
  }
  
  async checkIssueV2(
    params: CheckTicketPusatResolusiRequest
  ): Promise<TicketListItem[]> {
    const res = await this.service.invoke(
      "GET",
      this.endpoints.checkIssueV2(params)
    );

    return this.mapper.convertCheckIssuePusatResolusiV2FromApi(res);
  }

  async followTicket(payload: FollowTicketApiRequest): Promise<ResponsePayload> {
    const res = await this.service.invoke(
      "POST",
      this.endpoints.followTicket(payload.id),
      undefined,
      payload
    );

    return this.mapper.convertResponseFollowTicketFromApi(res);
  }

  async finishIssue(
    id: number,
    payload: FinishIssuePusatResolusiV2Request
  ): Promise<ResponsePayload> {
    const res = await this.service.invokePostWithFormData(
      "POST",
      this.endpoints.finishIssue(id),
      undefined,
      payload as FinishIssuePusatResolusiV2Request
    );

    return this.mapper.convertResponseFollowTicketFromApi(res);
  }
  async reopenIssue(
    id: number,
    payload: ReopenPusatResolusiV2Request
  ): Promise<ResponsePayload> {
    const res = await this.service.invokePostWithFormData(
      "POST",
      this.endpoints.reopenIssue(id),
      undefined,
      payload as ReopenPusatResolusiV2Request
    );

    return this.mapper.convertResponseFollowTicketFromApi(res);
  }
  async getTicketDetail(id: number): Promise<TicketDetail> {
    const res = await this.service.invoke(
      "GET",
      this.endpoints.getTicketDetail(id),
    );

    return this.mapper.convertTicketDetailFromApi(res);
  }

  async getTicketAction( id: number, payload: GetTicketActionRequest): Promise<TicketAction> {
    const resp = await this.service.invoke(
      "GET",
      this.endpoints.getTicketAction(id, payload),
      undefined,
      undefined
    );

    return this.mapper.convertTicketActionFromApi(resp);
  }

  async submitNote(payload: SubmitNotePusatResolusiRequest): Promise<boolean> {
    await this.service.invoke(
      "POST",
      this.endpoints.submitNote(payload.id),
      undefined,
      payload
    )

    return true;
  }

  async create(
    payload: CreatePusatResolusiV2RequestInterface
  ): Promise<TicketPusatResolusiDetail> {
    const resp = await this.service.invokePostWithFormData(
      "POST",
      this.endpoints.create(),
      {},
      payload as CheckTicketPusatResolusiRequest
    );
    return this.mapper.convertCreateTicketPusatResolusiFromApi(resp);
  }

  async sendChat(
    id: number,
    payload: SendChatPusatResolusiV2RequestInterface
  ): Promise<ResponsePayload> {
    const resp = await this.service.invokePostWithFormData(
      "POST",
      this.endpoints.sendChat(id),
      {},
      payload as SendChatPusatResolusiRequest
    );
    return this.mapper.convertResponseSendChatFromApi(resp);
  }

  async getMention(id: number): Promise<MentionsData[]> {
    const res = await this.service.invoke(
      "GET",
      this.endpoints.getMention(id)
    );

    return this.mapper.convertMentionDataFromApi(res);
  }

  async getConversation(
    id: number,
    params: GetConversationRequest
  ): Promise<HistoryChatResponse> {
    const resp = await this.service.invoke(
      "GET",
      this.endpoints.getConversation(id, params)
    );

    return this.mapper.convertHistoryChatResponseFromApi(resp);
  }
  

  connectConversationWebsocket(id: number): WebSocket {
    const socket = new WebSocket(`${Endpoints.baseUrl?.replaceAll("https", "wss")}/athena/ws/ticket/${id}?token=${getToken()}&hub_id=${getHubData()?.hubId || 0}`);

    
    return socket;
  }

  async getTemplateChat(): Promise<TemplateChat[]> {
    const resp = await this.service.invoke(
      "GET",
      this.endpoints.templateChat()
    );

    return this.mapper.convertTemplateDataFromApi(resp);
  }

  async addTemplate(
    payload: AddTemplatePusatResolusiRequestInterface
  ): Promise<boolean> {
    await this.service.invoke(
      "POST",
      this.endpoints.addTemplate(),
      {},
      payload as AddTemplatePusatResolusiRequest
    );
    return true;
  }

  async getBulkDownload(params: ApiRequestList): Promise<BulkDownload> {
    const resp = await this.service.invoke(
      "GET",
      this.endpoints.getBulkDownload(params)
    );

    return this.mapper.convertBulkDownloadReportFromApi(resp);
  }
  async requestDownloadLaporan(payload: DownloadLaporanPusatResolusiV2RequestInterface): Promise<boolean> {
    await this.service.invoke(
      "POST",
      this.endpoints.requestDownloadLaporan(),
      undefined,
      payload as DownloadLaporanRequest
    )

    return true;
  }
}
